import { Component } from '@angular/core';

@Component({
  selector: 'fe-standard-care',
  templateUrl: './standard-care.component.html',
  styleUrls: ['./standard-care.component.scss']
})
export class StandardCareComponent {

}
